export enum DashboardMatchType {
    review = 'review',
    applied = 'applied',
    archived = 'archived',
}
